import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import ThemeConstants from '../../../theme/ThemeConstants';

const styles = {
  container: {
    px: '20px',
  },
  title: {
    color: ThemeConstants.grey[800],
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '10px',
  },
  checkbox: {
    marginBottom: '40px',
  },
  checkboxLabel: {
    fontSize: 11,
    color: ThemeConstants.grey[800],
  },
  horizontalField: {
    '& fieldset': { border: 'none' },
    '& label': {
      flex: 2,
      marginBottom: 3,
    },
    '& .MuiTextField-root': {
      flex: 1,
    },
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
